<template>
  <div v-if="posterList && posterList.length" class="mb-4">
    <div class="container">
      <div class="row gutters-10">
        <div v-for="item in posterList" :key="item.id" class="col-xl col-md-6">
          <div class="mb-3 mb-lg-0">
            <a class="d-block text-reset" href="javascript:void(0)">
              <img
                :src="getFileViewUrl(item.pic)"
                alt=""
                class="img-fluid w-100 ls-is-cached lazyloaded"
                @click="jump(item.url)"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: { posterList: Array }
};
</script>
